module.exports = __webpack_public_path__ + "static/media/location_icon.520a2553.png";